'use client'
import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { STEPS } from '@/src/constants/itinerary/steps'
import { FLIGHT_NOT_AVAILABLE } from '@/src/constants/itineraryStatus'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import { ErrorType } from '@/src/types/itinerary'
import { useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

const useItineraryIntialLoadData = () => {
    const itineraryId = useGetItineraryId()
    const {
        itineraryStatus,
        isLoading: isItineraryLoading,
        isUninitialized: isItineraryUninitialized,
        error: itineraryError
    } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data, isLoading, isSuccess, isUninitialized, error }) => ({
                itineraryStatus: data?.itineraryStatus || '',
                isLoading: isLoading,
                isSuccess: isSuccess,
                isUninitialized: isUninitialized,
                error: error
            })
        }
    )
    const queryParams = useSearchParams()
    const steps = useMemo(() => {
        const steps = [STEPS.REVIEW]
        if (queryParams.get('ancillaryEnabled') !== 'false') {
            steps.push(STEPS.ADDONS)
        }
        steps.push(STEPS.TRAVELLER_DETAILS)
        return steps
    }, [])

    const isLoading = isItineraryLoading || isItineraryUninitialized
    const { error: itineraryResponseError = '' } = (itineraryError as any) || {}

    const isFlightNotAvailable = itineraryStatus === FLIGHT_NOT_AVAILABLE
    const error: ErrorType = isFlightNotAvailable ? FLIGHT_NOT_AVAILABLE : itineraryResponseError || null

    return {
        steps,
        isLoading,
        error
    }
}

export default useItineraryIntialLoadData
